import React, { Component } from "react";
import * as Mui from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { withTranslation } from "react-i18next";
import { Close } from "@material-ui/icons";

class Search extends Component {
  render() {
    const { t, classes } = this.props;
    return (
      <Mui.FormControl
        variant="outlined"
        style={{ width: '100% !important' }}
        className={`default-form-field tbl-filter-field search ${classes?.root || ""}`}
      >
        <Mui.OutlinedInput
          value={this.props.value}
          placeholder={this.props.searchPlaceholder ?? t("COMMON.SEARCH_LABEL")}
          onChange={this.props.onSearch}
          data-cy="search-input"
          startAdornment={
            <Mui.InputAdornment position="start">
              <SearchIcon />
            </Mui.InputAdornment>
          }
          endAdornment={
            this.props.enableClear && this.props.value && (
              <Mui.InputAdornment position="end">
                <Mui.IconButton onClick={() => this.props.onSearch({ target: { value: '' } })}>
                  <Close />
                </Mui.IconButton>
              </Mui.InputAdornment>
            )
          }
        />
      </Mui.FormControl>
    );
  }
}
export default withTranslation()(Mui.withWidth()(Search));
